import { fetchItemDetails } from '../../helpers';
import { showArticolo } from '../../api';

// Get dalle api di un item (o articolo) tramite il suo id
export const getItemById = async (params) => {
    const { id } = params

    if(!id) return false

    try {
        return await fetchItemDetails(id)
            .then((productData) => productData)
            .catch((err) => false)
    } catch (error) {
        return false
    }
}

// Get dalle api di un item (o articolo) tramite il suo code e il suo brand code
export const getItemByCodeAndBrand = async (params) => {
    const { brandCode, productCode } = params

    if(!brandCode) return false
    if(!productCode) return false

    console.log('parameters => ', params)

    try {
        return await showArticolo(brandCode, productCode)
                .then((productData) => productData)
                .catch((err) => false)
    } catch (error) {
        return false
    }
}